import { createSlice } from '@reduxjs/toolkit';

export const address = createSlice({
  name: 'address',
  initialState: {
    data: [],
  },

  reducers: {
    setAddress: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setAddress } = address.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getAddress = (state) => {
  return state.address.data;
};

export default address.reducer;
